export default class EventListController {
    constructor(userService, eventsService, $window) {
        this.$window = $window;

        userService.getAdmins().then(resp => {
            this.users = resp.data;
        });

        eventsService.getEvents().then(resp => {
            this.events = resp.data;
        });
    }

    editEvent(id){
        this.$window.location.href = "#!/manage/events/edit/" + id;
     }
}



// WEBPACK FOOTER //
// ./src/js/components/events/events.list.controller.js